const categories = [
  {
    icon: 'ri-rocket-line',
    title: 'Getting Started',
    description: 'Set up your account, install the Chrome extension, and build your Master Profile.',
    links: [
      { label: 'Create your free account', href: 'https://app.jobos.dev/auth' },
      { label: 'Install the Chrome extension', href: 'https://chrome.google.com/webstore' },
      { label: 'Build your Master Profile', href: 'https://app.jobos.dev/docs' },
    ],
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Application Tracker',
    description: 'Track every job application, set reminders, and manage your pipeline.',
    links: [
      { label: 'Add your first application', href: 'https://app.jobos.dev/docs' },
      { label: 'Import jobs from LinkedIn', href: 'https://app.jobos.dev/docs' },
      { label: 'Set follow-up reminders', href: 'https://app.jobos.dev/docs' },
    ],
  },
  {
    icon: 'ri-magic-line',
    title: 'ATS Autofill',
    description: 'Autofill Workday, Greenhouse, Lever, iCIMS, and 5+ more platforms instantly.',
    links: [
      { label: 'Supported ATS platforms', href: '/ats-platforms' },
      { label: 'Autofill not working?', href: 'https://app.jobos.dev/docs' },
      { label: 'Custom field mapping', href: 'https://app.jobos.dev/docs' },
    ],
  },
  {
    icon: 'ri-brain-line',
    title: 'AI Resume Tailoring',
    description: 'Tailor your resume and cover letter to any job description with AI.',
    links: [
      { label: 'How AI tailoring works', href: 'https://app.jobos.dev/docs' },
      { label: 'Improve your match score', href: 'https://app.jobos.dev/docs' },
      { label: 'Cover letter generator', href: 'https://app.jobos.dev/docs' },
    ],
  },
  {
    icon: 'ri-shield-keyhole-line',
    title: 'Account & Billing',
    description: 'Manage your subscription, update payment info, or cancel anytime.',
    links: [
      { label: 'Upgrade to Pro', href: 'https://app.jobos.dev/billing' },
      { label: 'Cancel subscription', href: 'https://app.jobos.dev/billing' },
      { label: 'Request a refund', href: 'https://app.jobos.dev/billing' },
    ],
  },
  {
    icon: 'ri-global-line',
    title: 'Global Job Boards',
    description: 'JobOS works with job boards in 50+ countries including Naukri, Rozee.pk, and more.',
    links: [
      { label: 'Supported job boards', href: 'https://app.jobos.dev/job-boards' },
      { label: 'Request a new board', href: 'https://app.jobos.dev/roadmap' },
      { label: 'International ATS support', href: '/ats-platforms' },
    ],
  },
];

export default function SupportCategories() {
  return (
    <section className="py-16 bg-white dark:bg-[#0A0E1A]">
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white mb-3 tracking-tight">
            Browse by Topic
          </h2>
          <p className="text-gray-500 dark:text-[#94A3B8] text-base max-w-xl mx-auto">
            Jump straight to the help you need.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((cat) => (
            <div
              key={cat.title}
              className="bg-gray-50 dark:bg-[#111827] border border-gray-100 dark:border-[#1E2A3B] rounded-xl p-6 hover:border-[#6366F1]/40 dark:hover:border-[#6366F1]/40 transition-all duration-200 group"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-[#6366F1]/10 dark:bg-[#6366F1]/15 mb-4 group-hover:bg-[#6366F1]/20 transition-colors">
                <i className={`${cat.icon} text-xl text-[#6366F1]`}></i>
              </div>
              <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">{cat.title}</h3>
              <p className="text-sm text-gray-500 dark:text-[#94A3B8] mb-4 leading-relaxed">{cat.description}</p>
              <ul className="space-y-2">
                {cat.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target={link.href.startsWith('http') ? '_blank' : undefined}
                      rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                      className="flex items-center gap-2 text-sm text-[#6366F1] hover:text-[#4F46E5] dark:text-[#818CF8] dark:hover:text-[#6366F1] transition-colors cursor-pointer"
                    >
                      <i className="ri-arrow-right-s-line text-base"></i>
                      <span>{link.label}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
